module.exports = __webpack_public_path__ + "static/media/hamburger.6d936a71.svg";